import React, {useEffect} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {fetchRestaurantById, updateRestaurant} from "../../store/restaurant-slice"; // Adjust these imports according to your store
import {restaurantSchema} from "../../schema/restaurantSchema"; // Ensure you have a corresponding schema for restaurants
import {getFormData} from "../../models/restaurantModel"; // Adjust this import to match your model
import SubHeader from "../../components/header/SubHeader";
import Button from "../../components/common/button/Button";
import Form from "../../components/common/form/Form";
import {getValidatedLimit} from "../../components/Utility";

const RestaurantEdit = () => {
    const params = useParams();
    const navigator = useNavigate();
    const dispatch = useDispatch();
    const {pagination} = useSelector(state => state.restaurant);
    const {limit, currentPage} = getValidatedLimit(pagination);

    const {
        items,
        updateStatus,
        fetchByIdStatus,
        error
    } = useSelector(state => state.restaurant); // Adjust this selector to your restaurant slice

    useEffect(() => {
        dispatch(fetchRestaurantById(params.restaurantId)); // Ensure you're using the correct ID parameter
    }, [dispatch, params.restaurantId]);

    const restaurant = items.find(item => item.id === params.restaurantId); // Ensure correct ID matching

    useEffect(() => {
        if (updateStatus === "success") {
            navigator(`../../?page=${currentPage}&limit=${limit}`); // Adjust navigation as needed
        }
    }, [updateStatus, navigator, currentPage, limit]);

    const formSubmitHandler = (data) => {
        dispatch(updateRestaurant({...data, id: restaurant._id})); // Ensure this action is correctly defined
    };

    const formCancelHandler = () => {
        navigator(`../../?page=${currentPage}&limit=${limit}`); // Adjust navigation as needed
    };

    const schema = restaurantSchema(); // Adjust the schema as necessary
    const initialData = getFormData(restaurant); // Make sure getFormData is correctly implemented for restaurant data

    return (
        <>
            <SubHeader title="Update Restaurant">
                <Button to={`../../?page=${currentPage}&limit=${limit}`}
                        className="btn-sm bg-secondary bg-opacity-50">Back</Button>
            </SubHeader>
            <div className="container p-0 ms-0">
                <div className="row">
                    <div className="col-xl-8">
                        {fetchByIdStatus === "loading" && <p>Loading...</p>}
                        {fetchByIdStatus === "failed" && <h6 className="text-danger">{error}</h6>}
                        {fetchByIdStatus === "success" &&
                            <Form
                                onFormSubmit={formSubmitHandler}
                                onFormCancel={formCancelHandler}
                                schema={schema}
                                inline={false}
                                initialData={initialData}
                                status={updateStatus}
                                error={error}
                            />
                        }
                    </div>
                </div>
            </div>
        </>
    );
};

export default RestaurantEdit;
